import React from "react";
import "./App.css";
import Header from "./components/Header";
import Mission from "./components/Mission";
import TBM from "./components/TBM";
import Team from "./components/Team";
import Timeline from "./components/Timeline";
import BecomeASponsor from "./components/Contact";
import Sponsors from "./components/Sponsors";
import ScrollReveal from "./components/ScrollReveal";

function App() {
  return (
    <div className="App">
      <Header />
      <ScrollReveal>
        <Mission />
      </ScrollReveal>
      <ScrollReveal direction="right" delay={50}>
        <div id="tbm">
          <TBM />
        </div>
      </ScrollReveal>
      <ScrollReveal direction="left" delay={150}>
        <div id="team">
          <Team />
        </div>
      </ScrollReveal>
      <ScrollReveal direction="left" delay={250}>
        <div id="timeline">
          <Timeline />
        </div>
      </ScrollReveal>
      <ScrollReveal direction="up" delay={350}>
        <div id="sponsors">
          <Sponsors />
        </div>
      </ScrollReveal>
      <ScrollReveal delay={450}>
        <div id="become-a-sponsor">
          <BecomeASponsor />
        </div>
      </ScrollReveal>
    </div>
  );
}

export default App;
